import React, { Component } from "react"
import {Alert, Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, Label, Popover , PopoverHeader, PopoverBody } from "reactstrap";
import { Link } from 'react-router-dom'
import cookie from 'react-cookies'
import statesInitials from "../helpers/statesInitials"
import getAllDistrictsInState from '../helpers/users/getAllDistrictsInState'
import sortByPropText from '../helpers/content/manageSets/sortByPropText'
import getOneByProp from '../helpers/users/getOneByProp'
import welcome from './../images/mp-online-beta-welcome-image.svg'
import { map } from 'lodash';

/*
  <Login
    emailVal={this.state.email}
    handleChange={this.handleChange}
    passwordVal={this.state.password}
    handleSubmit={this.handleSubmit}
    notFound={this.props.notFound}
    isFetching={this.props.isFetching}
    isAuthingEducator={this.props.isAuthingEducator}
    isAuthingEducatorError={this.props.isAuthingEducatorError}
    isAuthing={this.props.isAuthing}
    isAuthingError={this.props.isAuthingError}
    history={this.props.history}
    location={this.props.location}
  />
*/

class Login extends Component {
  state = {
    geoState: '',
    districts: null,
    fetchingDistricts: false,
    fetchingDistrictsError: '',
    selectedDistrictId: '',
    selectedDistrict: null,
    err : false,
    msg:'',
    validate : true,
    email: '',
    password: '',
  }
 componentWillReceiveProps(nextProps){
   const email = nextProps.emailVal
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    // var address = document.getElementById[email].value;
    if (reg.test(email) == false)
    {

      this.setState({validate : false})
    }
    else {
      this.setState({validate:true})

    }

 }

  handleChange = (e) => {
    const { target } = e
    const value = target.value;
    if (target.placeholder == 'Username') {
      cookie.save(target.name, value, { path: '/' });
    }else{
      cookie.save(target.name, '', { path: '/' });
    }
    this.props.handleChange(e)
    // this.setState({
    //   [target.name]: value
    // })
  }
  // If on username login route, handles when user selects
  // their district.
  handleSelectDistrict = ({ target }) => {
    const { districts } = this.state
    const selectedDistrictId = target.value
    cookie.save('selectedDistrictId', target.value, { path: '/' });
    cookie.save('selectedDistrict', getOneByProp(districts, 'id', selectedDistrictId), { path: '/' });
    this.setState({
      selectedDistrictId,
      selectedDistrict: getOneByProp(districts, 'id', selectedDistrictId),
    })
  }
 // If on username login route, handles when user selects
  // their district.
  handleSelectDistrict = ({ target }) => {
    const { districts } = this.state
    const selectedDistrictId = target.value
    cookie.save('selectedDistrictId', target.value, { path: '/' });
    cookie.save('selectedDistrict', getOneByProp(districts, 'id', selectedDistrictId), { path: '/' });
    this.setState({
      selectedDistrictId,
      selectedDistrict: getOneByProp(districts, 'id', selectedDistrictId),
    })
  }

  redirectToLogin = () =>{
    this.props.history.push('/login')
  }
  // If on username login route, this handles when the user selects
  // the geographic state they are located in.
  handleGeoStateChange = ({ target }) => {
    cookie.save('district_id', target.value, { path: '/' });
    this.setState({ [target.name]: target.value })
    if (target.value) {
      // Gets all the districts in the state to populate
      // the district select.
      getAllDistrictsInState(target.value)
        .then((districts) => {
          this.setState({
            selectedDistrict: null,
            selectedDistrictId: '',
            fetchingDistricts: false,
            districts,
            fetchingDistrictsError: ''
          })
          cookie.save('districts', this.toObject(districts), { path: '/' });

        })
        .catch(error => this.setState({
          fetchingDistricts: false,
          fetchingDistrictsError: error,
          districts: null,
        }))
    } else this.setState({
      districts: null,
      selectedDistrict: null,
      selectedDistrictId: '',
    })
  }


  //Array to Object
  toObject = (arr) => {
    var rv = {};
    for (var i = 0; i < arr.length; ++i) {
      if (arr[i] !== undefined) {
        let rr = { name: arr[i].name, id: arr[i].id }
        rv[i] = rr;

      }
    }
    return rv;
  }
  componentDidMount() {
    let email = '';
    if(this.props.location.pathname == '/signin-username')
    {
      email = cookie.load('email');
    }
    let district = cookie.load('districts');
    let district_array = [];
    var result = map(district, (dis) => {
      return dis;
    });
    this.setState({
      districts: result,
      selectedDistrict: cookie.load('selectedDistrict'),
      geoState: cookie.load('district_id'),
      selectedDistrictId: cookie.load('selectedDistrictId'),
      email: email,
    });

  }
  render() {
    const { geoState, selectedDistrictId, districts, email, password } = this.state
    const { handleGeoStateChange, handleSelectDistrict, handleChange } = this
    const {
      err,
      location,
      emailVal,
      passwordVal,
      handleSubmit,
      isAuthing,
      isAuthingError,
      reset,
      emailStatus,
      passwordStatus,
      lock,
      emailAtUsername,
      emailatusernamestatus,
      iswait,
      history
    } = this.props
    const usernameMode = location.pathname === '/signin-username'

    const sortedDistricts = districts ? sortByPropText(districts, 'name') : []

    let error = null ;
    let message = null ;
      if(err){
        if (this.state.validate && !usernameMode){
        error = (
          <div className = "xs-12" style={{'color':'orange','position':'absolute' , 'width':'100%', 'left':'0px','top':'-20px'}}>
            Invalid Email Address or Password. <br /><Link to='/reset/request-reset'>Click here</Link> to reset your password.
          </div>
        )

      }
      else if (!this.state.validate && !usernameMode) {
        error = (
          <div style={{'color':'orange','position':'absolute' , 'width':'100%', 'left':'0px','top':'-20px'}} className='mt-1'>
            If you are trying to sign in with a username, please click<span> Log in using your username</span>
          </div>
        )
      }
      else {
        null
      }
    }
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-0" style= {{"height" : "auto"}}  >
              <Card className="text-white col-sm-5  py-5 d-md-down-none" style={{ 'backgroundColor': '#194250','borderTopRightRadius': '0', 'borderBottomRightRadius': '0' }}>
                  <CardBody className="card-body text-center">
                    <div style= {{"marginTop": " 70px"}}>
                      <p><img src={welcome} alt="MasteryPrep Logo" /></p>
                    </div>
                  </CardBody>
                </Card>
                <Card className="p-4 " style={{ 'borderTopLeftRadius': '0', 'borderBottomLeftRadius': '0' }}>
                  {!usernameMode &&
                      <Row>
                        <Col xs='12' style = {{'textAlign': 'right'}}>
                          <Link to='/signin-username'>
                            <Button color = "link" style = {{'color':"#00C1AB",'position': 'relative','top': '-17px' ,'left': '15px'}}className="ml-5">

                              Log in using your username
                            </Button>
                            <hr style={{'position':"relative" ,'top':'-35px'}}/>
                          </Link>
                        </Col>
                        {message}
                      </Row>
                    }

                  <CardBody className="card-body" style = {{'marginTop' : '-25px'}} >
                    <h6><p>Log in Using Your{!usernameMode? (<span> Email Address</span>):(<span> Username</span>)}:</p></h6>
                    {usernameMode &&
                      <div >
                        <Label>Select Your State</Label>
                        <Input
                          type='select'
                          name='geoState'
                          value={geoState}
                          onChange={handleGeoStateChange}
                        >
                          <option value=''></option>
                          {statesInitials.map(initial =>
                            <option value={initial} key={initial}>{initial}</option>
                          )}
                        </Input>
                        <Label>Select Your School District</Label>
                        <Input
                          type='select'
                          name='district'
                          value={selectedDistrictId}
                          onChange={handleSelectDistrict}
                          disabled={!geoState}
                          className="mb-1"
                        >
                          <option value=''></option>
                          {sortedDistricts.map(district =>
                            <option value={district.id} key={district.id}>{district.name}</option>
                          )}
                        </Input>
                      </div>}
                    <InputGroup className="mb-1" style = {{'alignItems': 'center'}}>
                      <InputGroupAddon addonType='prepend' className="mt-3 "><i className="icon-user mt-3"></i></InputGroupAddon>
                      <Input
                        className= "ml-2 mt-3"
                        type='text'
                        name='email'
                        value={emailVal}
                        onChange={handleChange}
                        placeholder={usernameMode ? 'Username' : 'Enter email address'}
                        disabled={usernameMode && !selectedDistrictId}
                      />
                    </InputGroup>
                    <InputGroup className="mb-4" style = {{'alignItems': 'center'}} >
                      <InputGroupAddon addonType='prepend' className="mt-3"><i className="icon-lock mt-3"></i></InputGroupAddon>
                      <Input
                        diabled = 'true'
                        className= "ml-2 mt-4"
                        style = {{'alignItems': 'center'}}
                        type="password"
                        name='password'
                        value={passwordVal}
                        onChange={handleChange}
                        placeholder='Enter password'
                        onKeyPress={e => e.key === 'Enter' ? handleSubmit(e, selectedDistrictId) : null}
                        disabled={usernameMode && !selectedDistrictId}
                      />
                    </InputGroup>
                    <Row >
                      <Col  style={{'textAlign':'center'}}>
                        {error} 
                                                {/* if user tring to login via username but wrong credentials. */}
                                                {!emailatusernamestatus && err && usernameMode && 
                          <div style={{'color':'orange','position':'absolute' , 'width':'100%', 'left':'0px','top':'5px'}} className='mt-1'>
                          Your email or password is incorrect
                        </div>
                        }

                        {/* if a user is tring to login via email @ username-login */}
                         {!err && emailatusernamestatus && usernameMode && 
                          <div style={{'color':'orange','position':'absolute' , 'width':'100%', 'left':'0px','top':'-10px'}} className='mt-1'>
                          If you are trying to log in using your email address <br /><span style={{"cursor":"pointer","color":"#20a8d8"}} onClick={this.redirectToLogin}> Click here</span>
                        </div>
                        }

                        {/* submitting if on usernameMode with email */}
                        {usernameMode && this.state.validate &&<Button  
                        color="primary" 
                        style={{'width':'50%'}} 
                        className="px-4 mt-5" 
                        onClick= {(e) =>{emailAtUsername()}}>
                          {iswait ? <div><i className="fa fa-spinner fa-lg fa-spin"></i>{' '}Logging In...</div> : 'Login'}
                        </Button>}

                        {/* submitting if on usernameMode with username */}
                        {usernameMode && !this.state.validate &&<Button  
                        color="primary" 
                        style={{'width':'50%'}} 
                        className="px-4 mt-5" 
                        onClick= {(e) => handleSubmit(e, selectedDistrictId)}>
                          {isAuthing ? <div><i className="fa fa-spinner fa-lg fa-spin"></i>{' '}Logging In...</div> : 'Login'}
                        </Button>}

                        {/* submitting if on emailMode */}
                        {!usernameMode &&<Button  
                        color="primary" 
                        style={{'width':'50%'}} 
                        className="px-4 mt-5" 
                        onClick= {(e) => handleSubmit(e, selectedDistrictId)}>
                          {isAuthing ? <div><i className="fa fa-spinner fa-lg fa-spin"></i>{' '}Logging In...</div> : 'Login'}
                        </Button>}
                      </Col>
                      </Row>

                      <Row>
                      {!(reset && (this.state.validate) && (!usernameMode)) ? (
                      <Col xs="12" style={{'textAlign':'center'}}>
                        <Link to='/reset/request-reset'>
                          <Button style={{'color':'grey'}} color="link" className="px-0 mt-1" >Forgot password?</Button>
                        </Link>
                      </Col>
                    ):(
                      <Col xs="12" style={{'textAlign':'center'}} >
                        <Link to='/reset/request-reset'>
                          <Button style={{'color':'#00C1AB'}} color="link" className=" px-0 mt-1 " >Click here
                          </Button >
                        </Link>
                        <span  style={{'color':'grey','position':'relative','top':'3px'}}> to reset your password </span>
                      </Col>
                     )}
                       </Row>
                       <Row>
                      <Col style={{'textAlign':'center '}}>
                    {emailStatus && !passwordStatus ? (<span>
                          <Alert color="primary" style={{'position': 'absolute','left': '0px  ' ,'width': '100%', 'height':'40px'}}>
                          <strong>Email address is required </strong>
                          </Alert>
                          </span>):null
                      }
                      {passwordStatus && !usernameMode ? (<span>
                            <Alert color="primary" style={{'position': 'absolute','left': '0px  ' ,'width': '100%', 'height':'40px'}}>
                            <strong>Password is required </strong>
                            </Alert>
                            </span>):null
                      }
                      {emailStatus && passwordStatus && !usernameMode ? (<span>
                              <Alert color="primary" style={{'position': 'absolute','left': '0px  ' ,'width': '100%', 'height':'40px'}}>
                              <strong>Email and Password are required </strong>
                              </Alert>
                              </span>):null
                      }
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.js